<script lang="ts">
  import MaskInput from "./MaskInput.svelte";
  export let phoneInput: string | null;
  export let cleanedNumber: string = "";
  export let disable: boolean;
  export let require: boolean;
  export let inputIdString: string;
  export let action: any[];
  export let options;
  export let placeholder: string = "";
  export let label = "";
  export let description = "";
  export let onBlur: (e: any) => void = e => {};
  export let onFocus: (e: any) => void = e => {};
  export let name: string = "";

  export let classes;
  export let errorMessage = "";

  const cleanNumber = function () {
    if (phoneInput) {
      cleanedNumber = phoneInput.replace(/\D/g, "");
    } else {
      cleanedNumber = "";
    }
  };
  cleanNumber();

  function handleChange(event) {
    if (event && event.detail && event.detail.inputState) {
      phoneInput = event.detail.inputState.unmaskedValue;
    }
  }

</script>

<MaskInput
  {...options}
  size={20}
  value={cleanedNumber}
  on:change={handleChange}
  on:blur={onBlur}
  on:focus={onFocus}
  class="fizz-input-text fizz-full-width {classes}"
  disabled={disable}
  required={require}
  {placeholder}
  showMask
  maskChar=""
  id={inputIdString}
  {action}
  {label}
  {description}
  {name}
  {errorMessage}
/>
